import { render, staticRenderFns } from "./ChatSendButton.vue?vue&type=template&id=34835494&"
import script from "./ChatSendButton.vue?vue&type=script&lang=js&"
export * from "./ChatSendButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports